import React from 'react';
import { Card, CardContent, Typography, Box, Tooltip, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const StatCard = ({ title, value, icon, color, tooltip, footer }) => (
  <Card>
    <CardContent sx={{ py: { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2 }, '&:last-child': { pb: { xs: 1.5, sm: 2 } } }}>
      <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
        <Box sx={{ color, opacity: 0.7, flexShrink: 0, display: 'flex' }}>
          {icon}
        </Box>
        <Typography color="textSecondary" variant="body2" noWrap>
          {title}
        </Typography>
        {tooltip && (
          <Tooltip title={tooltip} arrow>
            <IconButton size="small" sx={{ padding: 0, flexShrink: 0 }}>
              <InfoOutlined sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Typography variant="h5" component="div" color={color} sx={{ fontWeight: 600 }}>
        {value}
      </Typography>
      {footer}
    </CardContent>
  </Card>
);

export default StatCard;
